module.exports = __webpack_public_path__ + "img/ExhibitNormalLeft.c9370b90.png";